import React from "react";
import { View, TouchableOpacity, Text, ScrollView } from "react-native";

import GlobalStyles from "../../../../globalStyles/globalStyles";
import { styles } from "../filterStyles/innerFilterStyles";
import ModalComponent from "../../../ModalComponent";
import FeedIcons from "../../../../assets/Icons/FeedIcons";
import { Colors } from "../../../../globalStyles/ColorConfig";

// Define the props interface
interface InnerFilterProps {
  isVisible: boolean;
  toggleModal: () => void;
  innerFilterLabel: string;
  children?: React.ReactNode;
  filters: any;
  setFilters: any;
}
export default function InnerFilter({
  isVisible,
  toggleModal,
  innerFilterLabel,
  children,
  filters,
  setFilters,
}: InnerFilterProps) {
  const handleApplyFilters = () => {
    setFilters((prevFilters: any) => ({
      ...prevFilters,
      appliedFilters: {
        ...prevFilters.appliedFilters,
        basicFilters: { ...prevFilters.basicFilters },
      },
    }));
    toggleModal();
  };
  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View style={styles.modalBackground}>
        <View style={styles.modalContainer}>
          <View style={styles.modalWrap}>
            <TouchableOpacity onPress={toggleModal} style={styles.FilterHeader}>
              <View style={styles.FilterHeaderFlex}>
                <FeedIcons.BackIcon />
                <Text style={GlobalStyles.title1}>{innerFilterLabel}</Text>
              </View>
            </TouchableOpacity>
            <ScrollView>{children}</ScrollView>
          </View>
        </View>
      </View>
      <View
        style={{
          paddingHorizontal: 16,
        }}
      >
        <TouchableOpacity
          style={[
            GlobalStyles.primaryButton,
            {
              backgroundColor: Colors.darkGreen,
              width: "100%",
              marginHorizontal: "auto",
              bottom: 20,
            },
          ]}
          onPress={handleApplyFilters}
        >
          <Text
            style={[
              GlobalStyles.ctaText,
              {
                color: "#FDFBF9",
              },
            ]}
          >
            Apply Filters
          </Text>
        </TouchableOpacity>
      </View>
    </ModalComponent>
  );
}
